import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';

import { IDescription } from 'typescriptDefs/pages/new-to-canada';

type Props = IDescription;

const Description = ({ cards, heading }: Props) => {
  return (
    <Section className="py-64 md:py-96">
      <Container className="px-32 xs:px-0">
        <div className="mx-auto mb-40 w-full text-center md:mb-64 md:w-1/2 [&_h2]:mb-8 [&_h2]:text-primary-350 md:[&_h2]:mb-24">
          <CustomPortableText content={heading} />
        </div>
        <div className="grid auto-rows-fr grid-cols-1 gap-32 md:grid-cols-3">
          {cards.map(({ description, heading, image }, i) => (
            <div key={i} className="rounded-16 bg-secondary-50 p-32 md:[&_p]:text-md">
              <GatsbyImage
                className="mb-20 h-32 w-32 text-success-500 md:mb-32"
                image={image.img.asset.gatsbyImageData}
                alt={image.altText}
              />
              <CustomPortableText
                headingStyles={{
                  h3: { className: 'mb-8 text-success-500 text-3xl md:text-3xl font-bold', headingStyle: true },
                }}
                content={heading}
              />
              <CustomPortableText content={description} />
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default Description;
